import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, FieldArray } from 'redux-form';
import _size from 'lodash/size';

import { entityType } from 'types';
import { FormGroupSelect } from 'components/Form';
import AutoCompleteMenuWrapper from 'components/AutoCompleteMenuWrapper';

import TrashTooltip from 'components/TrashTooltip';
import Button from 'components/Button';

import FeaturesFieldArray from './components/FeaturesFieldArray';

import './style.scss';

const operators = [
  {
    label: 'Exists',
    value: 'exists',
  },
  {
    label: 'Not Exists',
    value: 'not_exists',
  },
  {
    label: 'Exists Optionally',
    value: 'exists_optionally',
  },
];

const SIZE = 100;
const PAGE = 1;

class EntityFieldArray extends Component {
  static propTypes = {
    allEntities: PropTypes.arrayOf(entityType),
    entityFieldName: PropTypes.string,
    getAllEntities: PropTypes.func,
    index: PropTypes.number,
    isLoadingAllEntities: PropTypes.bool,
    item: entityType,
    operator: PropTypes.string,
    selectItem: PropTypes.func,
    onAddFeature: PropTypes.func,
    onChangeFeatureValues: PropTypes.func,
    onDelete: PropTypes.func,
    onDeleteFeature: PropTypes.func,
  };

  getEntities = (searchTerm = '') => {
    this.props.getAllEntities({
      page: PAGE,
      size: SIZE,
      name__icontains: searchTerm,
      scope__iexact: 'public',
    });
  };

  handleOpen = () => {
    this.getEntities();
  };

  handleChangeValue = value => {
    this.getEntities(value);
  };

  handleSelectItem = entity => {
    this.props.selectItem(entity, this.props.index);
  };

  handleDelete = () => {
    this.props.onDelete(this.props.index);
  };

  handleAddFeature = e => {
    e.stopPropagation();
    e.preventDefault();
    this.props.onAddFeature(this.props.index);
  };

  handleDeleteFeature = feature => {
    this.props.onDeleteFeature(this.props.index, feature);
  };

  handleChangeFeatureValues = (value, feature) => {
    this.props.onChangeFeatureValues(this.props.index, value, feature);
  };

  renderAddFeatureButton() {
    const { item } = this.props;
    if (
      !item.operator ||
      item.operator === 'not_exists' ||
      _size(item.features) === _size(item.entity_reference_obj.featuresMap) ||
      !item.entity_reference_obj.id
    ) {
      return null;
    }
    return (
      <Button
        data-test="add-feature-constraint-button"
        styleName="add-feature-btn"
        onClick={this.handleAddFeature}
      >
        Add Feature
      </Button>
    );
  }

  renderFeatures() {
    if (this.props.item.operator === 'not_exists') {
      return null;
    }
    return (
      <FieldArray
        component={FeaturesFieldArray}
        condition={this.props.item}
        featuresField={`${this.props.entityFieldName}`}
        name={`${this.props.entityFieldName}.features`}
        onChangeFeatureValues={this.handleChangeFeatureValues}
        onDelete={this.handleDeleteFeature}
      />
    );
  }

  render() {
    const {
      entityFieldName,
      item,
      isLoadingAllEntities,
      allEntities,
      operator,
    } = this.props;

    return (
      <React.Fragment>
        <div styleName="condition-entity">
          <div>
            <div data-test="entity-label" styleName="entity-label">
              Entity
            </div>
            <span styleName="seperator">-</span>
            <Field
              className="custom-autocomplete"
              component={AutoCompleteMenuWrapper}
              data-field="entity-autocomplete"
              isArchived={item.entity_reference_obj.archived}
              isLoading={isLoadingAllEntities}
              item={item.entity_reference_obj.name || ''}
              itemDisabledReason="Archived Entity!"
              items={allEntities}
              name={`${entityFieldName}.name`}
              placeholder="Select an entity"
              selectItem={this.handleSelectItem}
              onChangeValue={this.handleChangeValue}
              onOpen={this.handleOpen}
            />
            {item.entity_reference_obj.id && (
              <div styleName="operator">
                <Field
                  component={FormGroupSelect}
                  disabled={item.entity_reference_obj.archived}
                  name={operator}
                  options={operators}
                  placeholder="Select Operator"
                />
              </div>
            )}
          </div>
          <TrashTooltip text="Delete entity" onDelete={this.handleDelete} />
        </div>
        {this.renderFeatures()}
        {this.renderAddFeatureButton()}
      </React.Fragment>
    );
  }
}

export default EntityFieldArray;
